import React, { FC } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { ExtendedAuthProvider } from '../../util/auth0';
import { AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_DOMAIN, AUTH0_REDIRECTURL } from '../../config';

export const AppAuthProvider: FC<{ children: React.ReactNode }> = ({ children }) => {

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: AUTH0_AUDIENCE,
        redirect_uri: AUTH0_REDIRECTURL,
      }}
    >
      <ExtendedAuthProvider>
        {children}
      </ExtendedAuthProvider>
    </Auth0Provider>
  );
};
